import { differenceInMilliseconds } from "date-fns";
import { FIVE_MINUTES_MS } from "helpers";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParamSelector } from "redux/hooks";
import { IRootState } from "redux/reducer";
import { useAppDispatch } from "redux/store";
import { actions } from "./actions";
import { getLastLoadTimestamp } from "./selectors";
import { DictionaryErrorType, IDictionaryItem } from "./types";

const DICTIONARY_LOAD_THROTTLE_MS = FIVE_MINUTES_MS;
export const EMPTY_DICT = [];

const useDictionary = (
  key: string
): [IDictionaryItem[], DictionaryErrorType] => {
  const dictionary: IDictionaryItem[] = useSelector(
    (state: IRootState) => state.dictionaries.data?.[key]
  );
  const errorSelector = useSelector(
    (state: IRootState) => state.dictionaries.errors?.[key] ?? null
  );
  const dispatch = useAppDispatch();
  const loadedTimestamp = useParamSelector(getLastLoadTimestamp, key);
  const [error, setError] = useState<null | Error>(null);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (
      !dictionary &&
      (!loadedTimestamp ||
        differenceInMilliseconds(Date.now(), loadedTimestamp) >
          DICTIONARY_LOAD_THROTTLE_MS)
    ) {
      dispatch(actions.loadDictionary(key));
    }
    if (errorSelector) setError(errorSelector);
  }, [key, dictionary, loadedTimestamp]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return [dictionary || EMPTY_DICT, error];
};

export default useDictionary;
